// src/components/LoadingProgress.js

import React from 'react';
import { motion } from 'framer-motion';

const LoadingProgress = () => {
    return (
        <div className="fixed inset-0 bg-white flex justify-center items-center z-50">
            <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="flex flex-col items-center"
            >
                <img 
                    src="https://assets.apilabz.com/icons/apilabz.png" 
                    alt="API Labz" 
                    className="h-12 w-12 mb-3" 
                />
                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500 mb-2"></div>
                <p className="text-sm font-medium text-gray-600">Initializing...</p>
            </motion.div>
        </div>
    );
};

export default LoadingProgress;